/** Feature-scoped accents: inventory, target, AI guidance and outcomes stay distinct. */
export const CLIMATE_ACTION_COLORS = Object.freeze({
  inventory: '#10b981',
  inventoryDark: '#34d399',
  target: '#f97316',
  targetDark: '#fb923c',
  ai: '#B55F3D',
  aiDark: '#FFB995',
  aiSurface: '#FFF3EA',
  aiBorder: '#F4D7C4',
  other: '#64748B',
  otherBackground: '#F1F5F9',
});